<template>
  <div class="container-page big">
    <div class="title-block-top title-block-top--full">
      <div class="title-block-top__first title-block-top__first--full">
        <h2 class="title title--h2">Межправительственные комиссии (МПК), подкомиссии и&nbsp;рабочие группы (рг)</h2>
      </div>
      <div class="title-block-top__second title-block-top__second--full">
        <div class="commision-button-container">
          <div class="commision-button-container__left">
            <ButtonComponent
              v-permission="permissions.create"
              @click="addCardMPK()"
              mod="gradient-bg"
              class="button-redesign--mpk-commissions"
              >Создать МПК</ButtonComponent
            >
            <ButtonComponent
              v-permission="permissions.create"
              @click="addCardSC()"
              mod="gradient-bg"
              class="button-redesign--mpk-commissions btn-sc"
              >Создать подкомиссию</ButtonComponent
            >
            <ButtonComponent
              v-permission="permissions.create"
              @click="addCardRG()"
              mod="gradient-bg"
              class="button-redesign--mpk-commissions btn-rg"
              >Создать рабочую группу (РГ)</ButtonComponent
            >
          </div>
          <div class="commision-button-container__right">
            <ButtonComponent
              @click="exportExcel()"
              mod="gradient-bg"
              class="button-redesign--mpk-commissions btn-export"
              >Экспорт</ButtonComponent
            >
          </div>
        </div>
      </div>
    </div>

    <!-- table -->
    <div class="list-projects__body">
      <TableListCommissions
        :items="itemsTable"
        :canEdit="canEdit"
        :canDelete="canDelete"
        :isLoading="isLoading"
        v-model:filter="filter"
        :countryOptions="computedCountryList"
        :statusOptions="computedStatusList"
        @editCard="editCard"
        @deleteCard="deleteCard"
      />
    </div>

    <template v-if="page.pagesTotal > 1">
      <PaginationRedesigned
        :pageCount="page.pagesTotal"
        :currentPage="page.pageNumber"
        @change="onPageChange($event)"
        @more="onPageMore($event)"
      />
    </template>
  </div>
</template>

<script>
  import { debounce } from 'lodash';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import PaginationRedesigned from '@/common/components/redesigned/PaginationRedesigned.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import Utils from '@/common/utils';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';

  import { COMMISSION_TYPE_IDS, COMMISSION_TYPE_MAP } from '@/modules/mpk/utils/constants';

  import API from '../api/commission';
  import TableListCommissions from '../components/TableListCommissions.vue';

  const PERMISSIONS = {
    view: Constants.Permissions.MpkCommissionAccess,
    create: Constants.Permissions.MpkCommissionCreate,
    edit: Constants.Permissions.MpkCommissionEdit,
    delete: Constants.Permissions.MpkCommissionDelete,
  };

  export default {
    name: 'Commissions',
    components: {
      ButtonComponent,
      PaginationRedesigned,
      TableListCommissions,
    },
    mixins: [security],
    data() {
      return {
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },
        filter: {
          name: '',
          statusId: null,
          countryId: '',
          chairman: '',
          chairmanForeign: '',
          coChairman: '',
          secretary: '',
          lastEventFrom: null,
          lastEventTo: null,
          lastEventZasedFrom: null,
          lastEventZasedTo: null,
          nextEventZasedFrom: null,
          nextEventZasedTo: null,
        },
        mpkCountryList: [],
        statusList: [],
        page: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
          pagesTotal: 0,
        },
        itemsTable: [],
        canEdit: false,
        canDelete: false,
        isLoading: false,
        isInitialized: false,
      };
    },
    async created() {
      const isAllowed = await this.checkPermissionAndRedirect(PERMISSIONS.view);
      if (!isAllowed) return;

      this.checkPermission(PERMISSIONS.edit).then((response) => {
        this.canEdit = response.data;
      });
      this.checkPermission(PERMISSIONS.delete).then((response) => {
        this.canDelete = response.data;
      });

      loadFilter(this.$options.name, this.type).then((response) => {
        let filter = response;

        const urlCountryId = this.$route.query.countryId;
        if (filter) {
          this.filter = filter;
        }

        if (urlCountryId) {
          this.filter.countryId = urlCountryId;
        }

        Utils.loadMultiSelectOptions('countryList', this.mpkCountryList, true);
        Utils.loadMultiSelectOptions('mpkStatusList', this.statusList, true);
        this.loadPage();
        this.isInitialized = true;
      });
    },
    methods: {
      loadPage() {
        this.isLoading = true;
        API.search({
          ...this.filter,
          ...this.page,
        })
          .then((response) => {
            this.itemsTable = response.data.items;
            this.page.pageNumber = response.data.pageNumber;
            this.page.pagesTotal = response.data.pagesTotal;
            this.isLoading = false;
          })
          .catch((error) => {
            console.error(error);
            this.itemsTable = [];
            this.isLoading = false;
          });
      },

      changeFilter() {
        this.request.pageNumber = 1;
        saveFilter(this.$options.name, this.filter, this.type);
        this.loadPage(false);
      },

      exportExcel() {
        API.exportExcel(this.filter);
      },

      addCardMPK() {
        this.$router.push({
          name: 'CommissionCard',
          params: { id: 0, type: COMMISSION_TYPE_MAP.mp, action: 'create' },
        });
      },

      addCardSC() {
        this.$router.push({
          name: 'CommissionCard',
          params: { id: 0, type: COMMISSION_TYPE_MAP.sc, action: 'create' },
        });
      },

      addCardRG() {
        this.$router.push({
          name: 'CommissionCard',
          params: { id: 0, type: COMMISSION_TYPE_MAP.rg, action: 'create' },
        });
      },

      editCard(item) {
        this.$router.push({
          name: 'CommissionCard',
          params: { id: item.id, type: COMMISSION_TYPE_IDS[item.type], action: this.canEdit ? 'edit' : 'view' },
        });
      },

      deleteCard(id) {
        Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
          if (res.isConfirmed) {
            API.delete(id)
              .then(() => {
                Constants.alert.fire('Удаление', 'Запись удалена', 'success');
                this.loadPage();
              })
              .catch((error) => {
                Constants.alert.fire(
                  'Удаление',
                  error.response && error.response.data
                    ? error.response.data
                    : 'Запись не удалена. Она используется в других реестрах.',
                  'error',
                );
              });
          }
        });
      },

      onPageChange(pageNumber) {
        this.page.pageNumber = pageNumber;
        this.loadPage();
      },

      onPageMore(pageNumber) {
        this.page.pageNumber = pageNumber;
        API.search({
          ...this.filter,
          ...this.page,
        })
          .then((response) => {
            this.itemsTable = this.itemsTable.concat(response.data.items);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      debounceChangeValue: debounce(function () {
        this.changeFilter();
      }, 500),
    },
    computed: {
      permissions() {
        return PERMISSIONS;
      },
      // для правки отображения выбранного значения в `@vueform/multiselect`
      computedCountryList() {
        return [...this.mpkCountryList];
      },
      computedStatusList() {
        return [...this.statusList];
      },
    },
    watch: {
      filter: {
        handler() {
          this.page.pageNumber = 1;
          this.debounceChangeValue();
        },
        deep: true,
      },
      '$route.query.countryId': {
        handler(newCountryId) {
          if (this.isInitialized && newCountryId) {
            this.filter.countryId = newCountryId;
            this.loadPage();
          }
        },
        immediate: true,
        once: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/theme/default/title.scss';
  @import '@/assets/theme/default/table/table-base.scss';

  .commision-button-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    &__right {
      display: flex;
      flex-wrap: wrap;
    }

    @media (max-width: $mobile) {
      &__left,
      &__right {
        width: 100%;
      }

      &__filter {
        margin-top: 8px;
      }
    }
  }

  .btn-sc {
    @media (max-width: $mobile) {
      margin-top: 8px;
    }
  }

  .btn-export {
    @media ((min-width: calc($mobile + 1px)) and (max-width: 687px)) {
      margin-top: 8px;
    }
  }

  .btn-rg {
    @media ((min-width: calc($mobile + 1px)) and (max-width: 589px)) {
      margin-top: 8px;
    }
  }

  // ? для переопределения стиля в table-base, т.к. там вес селктора выше, а important ставить не хочется
  .middle-width.middle-width.middle-width {
    min-width: 136px;
    max-width: 136px;
  }

  .list-projects__body {
    padding: 0 80px;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
  }
</style>
